module.exports = __webpack_public_path__ + "static/media/55_000008.9802b0f3.jpg";